import React from 'react';
import { Typography, TextField, Grid, GridRow, GridCell, Button } from "rmwc";
import { UserContext } from '../../UserContext';
import useForm from '../../Hooks/UseForm'
const Login = () => {
  const email = useForm()
  const password = useForm()
  const { userLogin, error, login, loading } = React.useContext(UserContext);
  async function handleSubimit(event){  
    event.preventDefault()  
      userLogin({email: event.target.email.value, password:event.target.password.value})
  }
  return (
    <>
     <div className={"LoginContainer"}>
     <div className={"PageTitle"}>
        <h1><Typography use="headline1">TMENU LOGIN</Typography></h1>
      </div>
      <form className="formContainer" onSubmit={handleSubimit}>
        <Grid>
          <GridRow>
            <GridCell span={12}>
              <TextField type="email" name="email" fullwidth placeholder="Email" {...email} />
              {error}
              </GridCell>
          </GridRow>
          <GridRow>
            <GridCell span={12}>
              <TextField type="password" name="password" fullwidth placeholder="Password" {...password} />
              {error}
              </GridCell>
          </GridRow>
          <br/>
          <GridRow>
            <GridCell span={8}>

            </GridCell>
            
            <GridCell span={4}>
              <Button type="submit" className={"BtnDefaultTmenu"} label={loading?"Aguarde...":"Entrar"} icon="input"disabled={loading} />
              </GridCell>
          </GridRow>
        </Grid>
      </form>
    </div>
    </>
  )
}

export default Login;